export const QB_API_TOKEN = '@QB_API_TOKEN';
